import React from "react";
import styled from "styled-components";
import template from "../img/template.png";
import { motion } from "framer-motion";
import { useStateContext } from "../global-context/useGlobalContext";
import { Link } from "react-router-dom";

const Services = () => {
  const CardAnim = {
    hover: { boxShadow: "0px 0px 30px #F9CC0B" },
  };
  const { language } = useStateContext();
  return (
    <ServiceCards>
      <ServiceCard
        variants={CardAnim}
        whileHover="hover"
        whileTap="hover"
        transition={{ duration: 0.1, type: "tween" }}
      >
        <h1>
          <span>Web Design</span>
        </h1>
        {language ? (
          <div>
            <p>
              Nous comprenons les défis uniques auxquels les entreprises peuvent
              être confrontées lorsqu'il s'agit de créer une présence en ligne.
              C'est pour ça que nous nous efforçons de fournir un service
              personnalisé et adapté à chaque entreprise, en nous concentrant
              sur leurs besoins individuels et en créant des designs uniques
              pour leur marque.
              <br />
              <br /> En choisissant de travailler avec nous, vous bénéficiez :
            </p>
            <ul>
              <li>
                <span>D'une communication directe :</span> vous avez la garantie
                de travailler directement avec le concepteur à toutes les étapes
                du processus.
              </li>
              <li>
                <span>De designs uniques :</span> nous créons des designs
                personnalisés pour chaque compagnie, en mettant en avant leur
                marque et leur style.
              </li>
              <li>
                <span>De designs adaptatifs :</span> le concepteur s'assure que
                vos designs s'adaptent à tous les appareils pour une expérience
                utilisateur optimale.
              </li>
              <li>
                <span>D'un suivi après-vente :</span> nous nous mettons à votre
                disposition pour vous assister, même après la livraison de votre
                projet.
              </li>
            </ul>
            <p>
              Nous sommes passionnés par la création de designs uniques pour les
              entreprises et adorons travailler en étroite collaboration avec
              les entrepreneurs pour comprendre leurs besoins et leurs
              objectifs. Si vous recherchez un concepteur de sites web pour
              créer un design personnalisé pour votre entreprise, n'hésitez pas
              à nous{" "}
              <Link
                id="contact"
                to="/contact"
              >
                <span>contacter</span>
              </Link>{" "}
              pour discuter de vos besoins.
            </p>
          </div>
        ) : (
          <div>
            <p>
              We specialize in creating visually stunning and user-friendly
              websites. We understand the importance of a website as the first
              point of contact between a business and its potential customers,
              that's why we strive to create a website that not only looks great
              but also reflects the brand and values of the businesses we work
              with. <br />
              <br />
              We offer a wide range of web design services, including:
            </p>
            <ul>
              <li>
                <span>Custom Website Design:</span> We work closely with
                businesses to understand their needs and create a unique website
                that meets their expectations.
              </li>
              <li>
                <span>Responsive Design:</span> We ensure that the websites we
                design look and function seamlessly across all devices, from
                desktop to mobile.
              </li>
              <li>
                <span>Website Redesign:</span> We can breathe new life into
                existing websites with a fresh design and updated functionality.
              </li>
              <li>
                <span>Website Maintenance:</span> We offer ongoing website
                maintenance to keep sites running smoothly and ensure that it
                stays up-to-date with the latest technologies.
              </li>
            </ul>
            <p>
              We pride ourselves on delivering exceptional customer service and
              working closely with you throughout the entire process to ensure
              your satisfaction. We're committed to creating websites that not
              only look great but also drive results for you. If you're ready to
              take your online presence to the next level, please don't hesitate
              to{" "}
              <Link
                id="contact"
                to="/contact"
              >
                <span>contact us</span>{" "}
              </Link>{" "}
              today to schedule a consultation.
            </p>
          </div>
        )}
      </ServiceCard>
      <ServiceCard
        variants={CardAnim}
        whileHover="hover"
        whileTap="hover"
        transition={{ duration: 0.1, type: "tween" }}
      >
        <h1>
          {language ? (
            <span>Site web modèle</span>
          ) : (
            <span>Template Website</span>
          )}
        </h1>
        {language ? (
          <div className="sellingPoints">
            <p>
              Nous comprenons que toutes les entreprises n'ont pas les mêmes
              besoins en matière de conception de sites web. C'est pour ça que
              nous proposons un site web modèle, qui est un site web prédéfini
              qui peut être personnalisé pour s'adapter à votre marque et à vos
              besoins professionnels.
              <br />
              <br />
              Notre site web modèle est :
            </p>
            <ul>
              <li>
                <span>Rapide et facile à mettre en place :</span> nous nous
                occupons de la conception et du développement pour que vous
                puissiez vous concentrer sur votre activité.
              </li>
              <li>
                <span>Personnalisable :</span> notre modèle est entièrement
                personnalisable pour s'adapter à votre marque et à vos besoins
                professionnels.
              </li>
              <li>
                <span> Adaptatif :</span> notre modèle est conçu pour être
                adaptatif et de qualité sur tous les appareils.
              </li>
              <li>
                <span>Abordable :</span> notre site web modèle est une option
                abordable pour les entreprises qui ont un budget serré.
              </li>
              <li>
                <span>Facile d'utilisation :</span> notre modèle est conçu pour
                être facile à naviguer et convivial pour les utilisateurs, ce
                qui facilite la recherche de vos clients.
              </li>
            </ul>
            <p>
              Nous nous félicitons de fournir un service client exceptionnel et
              de travailler en étroite collaboration avec les entreprises tout
              au long du processus pour assurer leur satisfaction. Si vous
              recherchez une solution rapide, facile et abordable pour vos
              besoins en conception de sites web, alors notre site web modèle
              pourrait être la solution idéale pour vous.
              <br />
              <br />
              Cliquez sur l'image pour voir le site :
            </p>
          </div>
        ) : (
          <div className="sellingPoints">
            <p>
              We understand that not all businesses have the same needs when it
              comes to web design. That's why we offer a template website, which
              is pre-designed, that can be customized to fit your brand and
              business needs. <br />
              <br />
              Our template website is:
            </p>
            <ul>
              <li>
                <span>Quick and easy to set up:</span> We take care of the
                design and development so that you can focus on running your
                business.
              </li>
              <li>
                <span>Customizable:</span> Our templates are fully customizable
                to fit your brand and business needs.
              </li>
              <li>
                <span> Responsive:</span> All of our templates are built to be
                responsive and look great on any device.
              </li>
              <li>
                <span>Affordable:</span> Our template websites are an affordable
                option for businesses that are on a tight budget.
              </li>
              <li>
                <span>User-friendly:</span> Our templates are designed to be
                easy to navigate and user-friendly, making it easy for your
                customers to find what they're looking for.
              </li>
            </ul>
            <p>
              We pride ourselves on delivering exceptional customer service and
              working closely with our clients throughout the entire process to
              ensure their satisfaction. If you're looking for a quick, easy,
              and affordable solution to your web design needs, then our
              template websites might be the perfect fit for you.
              <br />
              <br />
              Click on the template to see the website:
            </p>
          </div>
        )}
        <a
          href="https://j-cesar-design-template.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={template}
            alt="website template"
          />
        </a>
        {language ? (
          <p>
            N'hésitez pas à nous{" "}
            <Link
              id="contact"
              to="/contact"
            >
              <span>contacter</span>
            </Link>{" "}
            pour prendre rendez-vous pour une consultation.
          </p>
        ) : (
          <p>
            Don't hesitate to
            <Link
              id="contact"
              to="/contact"
            >
              <span> contact us</span>
            </Link>{" "}
            today to schedule a consultation.
          </p>
        )}
      </ServiceCard>
      <ServiceCard
        variants={CardAnim}
        whileHover="hover"
        whileTap="hover"
        transition={{ duration: 0.1, type: "tween" }}
      >
        <h1>
          {language ? <span>Graphisme</span> : <span>Graphic Design</span>}
        </h1>
        {language ? (
          <div className="sellingPoints">
            <p>
              En tant qu'artiste graphique solo, je suis passionnée par la
              création de designs inspirants qui permettent aux entreprises et
              aux individus de se démarquer. Mon expertise en matière de
              création de logo, d'affiches, de flyers, de templates pour les
              réseaux sociaux et autres techniques artistiques vous garantit une
              expérience créative unique pour votre projet.
              <br />
              <br />
              En choisissant de travailler avec moi, vous bénéficiez :
            </p>
            <ul>
              <li>
                <span>D'une approche artistique :</span> je m'inspire de votre
                vision pour créer des designs uniques qui reflètent votre
                personnalité ou celle de votre entreprise.
              </li>
              <li>
                <span>D'un processus collaboratif :</span> je suis ouverte à vos
                suggestions et vous invite à participer à chaque étape de la
                création pour que le résultat final soit le plus proche de vos
                attentes.
              </li>
              <li>
                <span> D'un accompagnement sur mesure :</span> je m'engage à
                vous aider à mettre en valeur votre projet en vous fournissant
                les outils nécessaires pour diffuser votre travail, comme des
                templates pour les réseaux sociaux, des flyers, des affiches,
                etc.
              </li>
            </ul>
            <p>
              Je suis convaincue que l'art est un moyen de créer des ponts entre
              les gens et de susciter des émotions. Si vous recherchez une
              artiste graphique solo pour donner vie à vos idées, n'hésitez pas
              à me{" "}
              <Link
                id="contact"
                to="/contact"
              >
                <span>contacter</span>
              </Link>{" "}
              pour discuter de vos projets.
            </p>
          </div>
        ) : (
          <div className="sellingPoints">
            <p>
              As a solo graphic designer, I am passionate about creating
              inspiring designs that allow businesses and individuals alike to
              stand out. My expertise when it comes to creating logos, posters,
              flyers, social media templates and other artistic techniques, you
              guarantee a unique creative experience for your project.
              <br />
              <br />
              By choosing to work with me, you benefit from:
            </p>
            <ul>
              <li>
                <span>An artistic approach:</span> I get inspired by your vision
                to create unique designs that reflect your personality or your
                business' personality.
              </li>
              <li>
                <span>A collaborative process:</span> I am open to your
                suggestions and invite you to participate in each step of the
                creation, so that the final result is closest to your
                expectations.
              </li>
              <li>
                <span> Tailor-made support:</span> I'm engaged to help you
                highlight your project by giving you the tools necessary to
                publish your work, such as social media templates, flyers,
                posters, etc.
              </li>
            </ul>
            <p>
              I'm convinced art is way to create bridges between people and to
              stimulate emotions. If you're looking for a solo graphic artist to
              give life to your ideas, don't hesitate to{" "}
              <Link
                id="contact"
                to="/contact"
              >
                <span> contact me</span>
              </Link>{" "}
              to discuss your projects.
            </p>
          </div>
        )}
      </ServiceCard>
    </ServiceCards>
  );
};

export default Services;

const ServiceCard = styled(motion.div)`
  backdrop-filter: blur(15px);
  border: solid 1px #f9cc0b;
  color: white;

  height: fit-content;
  width: 40vw;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5vh 0vw;
  margin: 5vh 5vw;
  @media (max-width: 700px) {
    margin-bottom: 10vh;
    width: 80vw;
  }
  h3,
  h2 {
    padding: 1.5vh 1rem;
    text-align: center;
    .price {
      color: white;
    }
  }
  p,
  li {
    padding: 1.5vh 3vw;
    text-align: start;
    font-size: 1.2rem;
    list-style: none;
    @media (max-width: 700px) {
      width: 60vw;
    }
  }
  img {
    width: 34vw;
    height: auto;
    border-radius: 1rem;
    @media (max-width: 700px) {
      width: 60vw;
    }
  }
  #contact:hover {
    text-decoration: solid underline #f9cc0b;
  }
`;
const ServiceCards = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100vw;
  height: fit-content;
  align-items: center;
  padding: 10vh 0;
  @media (max-width: 700px) {
    padding-top: 5vh;
  }
`;
